import { render, staticRenderFns } from "./RestWithLast3RealOrdersDeleted.vue?vue&type=template&id=664e7e5e"
import script from "./RestWithLast3RealOrdersDeleted.vue?vue&type=script&lang=js"
export * from "./RestWithLast3RealOrdersDeleted.vue?vue&type=script&lang=js"
import style0 from "./RestWithLast3RealOrdersDeleted.vue?vue&type=style&index=0&id=664e7e5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports